export enum ScimIdpEnum {
  entra = "entra",
  okta = "okta",
  google_workspace = "google_workspace",
  onelogin = "onelogin",
  ping_identity = "ping_identity",
  forgerock = "forgerock",
  sailpoint = "sailpoint",
  saviynt = "saviynt",
  ibm_verify = "ibm_verify",
  oracle_identity = "oracle_identity",
  cyberark = "cyberark",
  beyondtrust = "beyondtrust",
  auth_zero = "auth_zero",
  aws_iam_identity_center = "aws_iam_identity_center",
  rippling = "rippling",
  jumpcloud = "jumpcloud",
  cisco_duo = "cisco_duo",
  shibboleth = "shibboleth",
  workday = "workday",
  bamboohr = "bamboohr",
  adp = "adp",
  sap_successfactors = "sap_successfactors",
  ukg = "ukg",
  other = "other"
}